export const style = {
  wrapper: {
    sx: {
      px: 2,
    },
  },
} as const;
